import { Button } from "@mui/material";
import Modal from "../Modal";

const ResidentCheckinModal = ({
  openConfirmation,
  setOpenConfirmation,
  doCheckIn,
}) => {
  return (
    <Modal
      open={openConfirmation}
      handleClose={() => setOpenConfirmation(false)}
    >
      <div className="flex flex-col gap-4">
        <h1 className="text-xl font-bold">Confirm Weekly Check-In</h1>
        <div className="space-y-2">
          <p className="text-md text-gray-700 ">
            Are you sure you want to check in this user for this week?
          </p>
          <p className="text-sm italic text-gray-500 ">
            This will record their visit for the current week, update their
            weekly streak, and apply any eligible discount based on the updated
            streak.
          </p>
        </div>
        <div className="flex items-center gap-2 justify-end">
          <Button
            variant="outlined"
            size="small"
            onClick={() => setOpenConfirmation(false)}
          >
            Cancel
          </Button>
          <Button variant="contained" size="small" onClick={() => doCheckIn()}>
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ResidentCheckinModal;
